import RsoSettings from "./RsoSettings";

export default RsoSettings;
